import type { FC } from "react";

import classnames from "classnames";

import { useConfig } from "@jti/app-context/useConfig";
import { Badge } from "@jti/core-components/components/Badge";

import styles from "./RegionBadge.module.scss";

export type RegionBadgeProps = {
  regionCode?: string | null;
  isBundleItem?: boolean;
  className?: string;
};

export const RegionBadge: FC<RegionBadgeProps> = ({ regionCode, isBundleItem }) => {
  const config = useConfig();
  const regionSelectorData = config?.regionSelector;

  if (!regionCode || !regionSelectorData?.isRegionSelectorEnabled) {
    return null;
  }

  const regionLabel = regionSelectorData.regionOptions.find((option) => option.id === regionCode)?.regionName;

  if (!regionLabel) {
    console.warn(`Missing name for region code: ${regionCode}, region badge will not be rendered.`);
    return null;
  }

  return (
    <span
      className={classnames(styles.regionBadge, { [styles.bundleContainer]: isBundleItem })}
      data-testid="region-badge"
    >
      <Badge variant="neutral-subtle" label={regionLabel} isLabelSubtle={true} />
    </span>
  );
};
